/**
 * Coloured "chip" used to surface enum values (connector status,
 * security profile, firmware status, …). Self-contained — colour and
 * label are derived from the helpers in `utils/statusFormat.ts`.
 */

import React from 'react';
import { StyleSheet, Text, View, ViewStyle } from 'react-native';

import { OcppTheme } from './OcppTheme';

export interface OcppStatusPillProps {
  label: string;
  color?: string;
  size?: 'sm' | 'md';
  style?: ViewStyle;
}

const OcppStatusPill: React.FC<OcppStatusPillProps> = ({
  label,
  color = OcppTheme.accent,
  size = 'md',
  style,
}) => {
  const isSmall = size === 'sm';
  return (
    <View
      style={[
        styles.pill,
        {
          backgroundColor: `${color}33`,
          borderColor: color,
          paddingHorizontal: isSmall ? 8 : 10,
          paddingVertical: isSmall ? 2 : 4,
        },
        style,
      ]}
    >
      <Text
        numberOfLines={1}
        style={[
          styles.label,
          { color, fontSize: isSmall ? 11 : 12 },
        ]}
      >
        {label}
      </Text>
    </View>
  );
};

export default OcppStatusPill;

const styles = StyleSheet.create({
  pill: {
    alignSelf: 'flex-start',
    borderRadius: 999,
    borderWidth: StyleSheet.hairlineWidth,
  },
  label: {
    fontWeight: '700',
    letterSpacing: 0.2,
  },
});
